import React from 'react';
import { Link } from 'react-router-dom';
import Mark from './Mark';

function Footer() {
  return (
    <footer className="footer">
      <div className="wrap footer-inner">
        <div className="footer-brand">
          <div className="footer-lockup">
            <Mark size={32} />
            <span className="footer-wordmark">Zenbul</span>
          </div>
          <p className="footer-tagline">Engineering Silence.</p>
          <p className="footer-blurb">
            A proprietary low-frequency silencer that tracks the fan tone, and
            datacenter property-line noise held to a written SLA.
          </p>
        </div>

        <div className="footer-col">
          <p className="footer-col-head">Site</p>
          <Link to="/#problem">The problem</Link>
          <Link to="/#offer">What we sell</Link>
          <Link to="/#silencer">The silencer</Link>
          <Link to="/#guarantee">The guarantee</Link>
          <Link to="/#process">Process</Link>
          <Link to="/blog">Blog</Link>
          <Link to="/careers">Careers</Link>
        </div>

        <div className="footer-col">
          <p className="footer-col-head">Contact</p>
          <Link to="/#assessment">Request an assessment</Link>
          <a href="mailto:hello@zenbul.com">hello@zenbul.com</a>
        </div>
      </div>

      <div className="wrap footer-base">
        <span>&copy; {new Date().getFullYear()} Zenbul</span>
        <span className="footer-base-tag">Engineering Silence</span>
      </div>
    </footer>
  );
}

export default Footer;
